import React from "react";
import LegalPageLayout from "../components/LegalPageLayout";
import { Link } from "react-router-dom";

const DatenschutzPage = () => (
  <LegalPageLayout title="Datenschutzerklärung">
    <p className="text-[var(--vortex-text-secondary)]">
      Der Schutz Ihrer persönlichen Daten ist uns wichtig. Nachfolgend
      informieren wir Sie über die Verarbeitung personenbezogener Daten bei
      der Nutzung dieser Website gemäß der Datenschutz-Grundverordnung (DSGVO)
      und dem Bundesdatenschutzgesetz (BDSG).
    </p>

    <section>
      <h2 className="text-xl font-semibold text-[var(--vortex-text-primary)] mt-8 mb-2">
        1. Verantwortlicher
      </h2>
      <p>
        Verantwortlich für die Datenverarbeitung auf dieser Website ist:
        <br />
        Serafina Pflegedienst GmbH
        <br />
        Hindenburgstraße 77, 41542 Dormagen
        <br />
        E-Mail:{" "}
        <a
          href="mailto:info@serafina-pflegedienst.de"
          className="text-[var(--vortex-accent-primary)] hover:underline"
        >
          info@serafina-pflegedienst.de
        </a>
        <br />
        Telefon: 02133-21 84 111
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-[var(--vortex-text-primary)] mt-8 mb-2">
        2. Erhebung und Speicherung personenbezogener Daten
      </h2>
      <p>
        Beim Besuch unserer Website werden durch den Browser auf Ihrem Gerät
        automatisch Informationen an den Server gesendet (u. a. IP-Adresse, Datum
        und Uhrzeit des Zugriffs, verwendeter Browser und Betriebssystem). Diese
        Daten werden ausschließlich zur Gewährleistung eines störungsfreien
        Betriebs und zur Auswertung der Systemsicherheit erhoben. Eine
        Zuordnung zu einer bestimmten Person ist uns nicht möglich.
      </p>
      <p className="mt-4">
        Über unser Kontaktformular erfasste Daten (Name, E-Mail, Telefon,
        Nachricht und weitere von Ihnen angegebene Angaben) werden
        ausschließlich zur Bearbeitung Ihrer Anfrage verarbeitet und
        gespeichert. Die Verarbeitung erfolgt auf Grundlage Ihrer Einwilligung
        (Art. 6 Abs. 1 lit. a DSGVO) bzw. zur Durchführung vorvertraglicher
        Maßnahmen (Art. 6 Abs. 1 lit. b DSGVO).
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-[var(--vortex-text-primary)] mt-8 mb-2">
        3. Zweck der Verarbeitung
      </h2>
      <p>
        Wir verwenden Ihre Daten zur Beantwortung von Anfragen, zur
        Terminvereinbarung und zur Erbringung unserer Leistungen. Eine
        Weitergabe an Dritte erfolgt nur, soweit dies gesetzlich vorgesehen
        oder für die Vertragserfüllung erforderlich ist (z. B. Abrechnung mit
        Kostenträgern im Rahmen der Pflege).
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-[var(--vortex-text-primary)] mt-8 mb-2">
        4. Speicherdauer
      </h2>
      <p>
        Personenbezogene Daten werden nur so lange gespeichert, wie es für den
        genannten Zweck erforderlich ist oder gesetzliche Aufbewahrungsfristen
        bestehen. Kontaktanfragen werden in der Regel nach Abschluss der
        Bearbeitung gelöscht, sofern keine gesetzlichen Aufbewahrungspflichten
        entgegenstehen.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-[var(--vortex-text-primary)] mt-8 mb-2">
        5. Ihre Rechte
      </h2>
      <p>Sie haben gegenüber uns folgende Rechte hinsichtlich Ihrer Daten:</p>
      <ul className="list-disc pl-6 mt-2 space-y-1">
        <li>Recht auf Auskunft (Art. 15 DSGVO)</li>
        <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
        <li>Recht auf Löschung (Art. 17 DSGVO)</li>
        <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
        <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
        <li>Recht auf Widerspruch (Art. 21 DSGVO)</li>
        <li>Recht auf Widerruf Ihrer Einwilligung (Art. 7 Abs. 3 DSGVO)</li>
      </ul>
      <p className="mt-4">
        Sie haben zudem das Recht, sich bei einer Datenschutz-Aufsichtsbehörde
        zu beschweren. Zuständig ist die Landesbeauftragte für Datenschutz und
        Informationsfreiheit Nordrhein-Westfalen.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-[var(--vortex-text-primary)] mt-8 mb-2">
        6. SSL-/TLS-Verschlüsselung
      </h2>
      <p>
        Diese Seite nutzt aus Sicherheitsgründen eine SSL- bzw. TLS-Verschlüsselung.
        Eine verschlüsselte Verbindung erkennen Sie an der Adresszeile („https://“)
        und am Schloss-Symbol im Browser.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-[var(--vortex-text-primary)] mt-8 mb-2">
        7. Cookies
      </h2>
      <p>
        Informationen zur Verwendung von Cookies auf dieser Website finden Sie
        in unserer{" "}
        <Link to="/cookies" className="text-[var(--vortex-accent-primary)] hover:underline">
          Cookie-Richtlinie
        </Link>
        .
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-[var(--vortex-text-primary)] mt-8 mb-2">
        8. Google Analytics
      </h2>
      <p>
        Wir nutzen Google Analytics (GA4), um die Nutzung dieser Website
        auszuwerten. Die Auswertung erfolgt nur, wenn Sie über unseren
        Cookie-Hinweis zugestimmt haben. Dabei setzen wir die Anonymisierung
        von IP-Adressen ein. Google verarbeitet die Daten in der Regel in den
        USA. Weitere Informationen zur Datenerhebung und -nutzung durch Google
        finden Sie in der{" "}
        <a
          href="https://policies.google.com/privacy"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[var(--vortex-accent-primary)] hover:underline"
        >
          Datenschutzerklärung von Google
        </a>
        .
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-[var(--vortex-text-primary)] mt-8 mb-2">
        9. Microsoft Clarity
      </h2>
      <p>
        Wir setzen Microsoft Clarity ein, um zu erfassen, wie Sie unsere
        Website nutzen und mit ihr interagieren (z. B. durch Verhaltensmetriken,
        Heatmaps und Session-Aufzeichnungen). Dies dient der Verbesserung unserer
        Website und der Nutzererfahrung. Die Erfassung erfolgt nur mit Ihrer
        Einwilligung über unseren Cookie-Hinweis. Die Daten werden mit
        First- und Third-Party-Cookies sowie vergleichbaren Technologien
        erfasst. Weitere Informationen dazu, wie Microsoft Daten erhebt und
        nutzt, finden Sie in der{" "}
        <a
          href="https://www.microsoft.com/privacy/privacystatement"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[var(--vortex-accent-primary)] hover:underline"
        >
          Microsoft-Datenschutzerklärung
        </a>
        .
      </p>
    </section>

    <section className="mt-8 pt-6 border-t border-[var(--vortex-border)]">
      <p className="text-sm text-[var(--vortex-text-secondary)]">
        Stand: {new Date().toLocaleDateString("de-DE")}. Wir behalten uns
        vor, diese Datenschutzerklärung bei Bedarf anzupassen.
      </p>
    </section>
  </LegalPageLayout>
);

export default DatenschutzPage;
